import { useState } from "react";

import { Button, Span, Spinner } from "@virtual-brain-lib/frontend-design-system/ui";
import { cn } from "@virtual-brain-lib/frontend-design-system/utils";
import type { SourceFile } from "@virtual-brain-lib/types";

import { Markdown } from "../../../markdown";

type ThinkingMode = "thinking" | "searching";

interface MessageReasoningDropDownProps {
	readonly className?: string;
	readonly reasoningContent?: string | undefined;
	readonly isThinking: boolean;
	readonly thinkingMode?: ThinkingMode;
	readonly onSourceSelected?: ((params: SourceFile) => void) | undefined;
}

const thinkingModeLabels: Record<ThinkingMode, string> = {
	thinking: "Thinking",
	searching: "Searching",
};

export default function MessageReasoningDropDown({
	className,
	reasoningContent,
	isThinking,
	thinkingMode = "thinking",
	onSourceSelected,
}: MessageReasoningDropDownProps) {
	const [isReasoningOpen, setIsReasoningOpen] = useState(false);
	const contents = reasoningContent?.replaceAll("\n\n", "<br><br>");
	const chevronIcon = isReasoningOpen ? "chevronUp" : "chevronDown";

	return (
		<div className={cn("flex flex-col", className)}>
			<Button
				variant="ghost"
				size="xs"
				className="-ml-2 w-fit text-gray-500"
				rightIcon={isThinking ? undefined : chevronIcon}
				rightComponent={isThinking ? <Spinner size="xs" /> : undefined}
				onClick={() => {
					setIsReasoningOpen(!isReasoningOpen);
				}}
			>
				{thinkingModeLabels[thinkingMode]}
				<span className={cn(isThinking ? "opacity-100" : "opacity-0")}>...</span>
			</Button>
			{reasoningContent && (
				<Span
					variant="body-xs"
					color="defaultLight"
					className={cn(
						isReasoningOpen ? "py-3" : "h-0 overflow-hidden py-0 opacity-0",
						"ml-6 border-l-2 px-6 italic transition-all duration-300 ease-out",
					)}
				>
					<Markdown onSourceSelected={onSourceSelected}>{contents ?? ""}</Markdown>
				</Span>
			)}
		</div>
	);
}
